import * as React from 'react';
import { IntlContext } from '../Intl/IntlContext';
/**
 * @hidden
 */
export var useInternationalization = function () {
  return React.useContext(IntlContext);
};